import {UseMutationResult} from '@tanstack/react-query';
import {ColumnNames, ShipmentIds} from '@shipwell/backend-core-singlerequestparam-sdk';
import useGetShipmentsDownloadCsvMutation, {
  GetShipmentsDownloadCsvMutationOptions
} from './hooks/useGetShipmentsDownloadCsvMutation';

const ShipmentsDownloadCsv = ({
  shipmentIds,
  columnNames,
  options = {},
  children
}: {
  shipmentIds: ShipmentIds;
  columnNames: ColumnNames;
  options: GetShipmentsDownloadCsvMutationOptions;
  children: (child: UseMutationResult) => JSX.Element;
}) => children(useGetShipmentsDownloadCsvMutation({shipmentIds, columnNames, options}));

export default ShipmentsDownloadCsv;
